import { BASE_URL } from '../actions/global'

// RUTAS API
export const APP_USER = `${BASE_URL}/app-user`
export const APP_USER_ME = `${BASE_URL}/app-user/me`
export const APP_USER_REGISTER_USER = `${BASE_URL}/app-user/register-user`
export const APP_USER_UPDATE_ACCOUNT = `${BASE_URL}/app-user/update-account`
export const APP_USER_UPDATE_PASSWORD = `${BASE_URL}/app-user/update-password`
export const AUTH_APPROVE_USER_ACCOUNT = `${BASE_URL}/auth/approve-user-account`
export const AUTH_LOGIN = `${BASE_URL}/auth/login`
export const AUTH_SEND_EMAIL_RESET_PASSWORD = `${BASE_URL}/auth/send-email-reset-password`
export const AUTH_VERIFY = `${BASE_URL}/auth/is-verify`
export const AUTH_ACTIVATE_TENANT = `${BASE_URL}/auth/activate-tenant`
export const AUTH_VERIFY_USER = `${BASE_URL}/auth/verify-user`
export const CARBON_CALCULE_BY_ID = `${BASE_URL}/equation`
export const CATEGORY = `${BASE_URL}/category`
export const CATEGORY_TYPE = `${BASE_URL}/category-type`
export const CATEGORY_TYPE_BY_ID = `${BASE_URL}/category-type/category`
export const FAMILY = `${BASE_URL}/family`
export const FAMILY_TOTAL = `${BASE_URL}/family/count-only`
export const FAMILY_UPDATE = `${BASE_URL}/family/update-family`
export const FAMILY_CREATE = `${BASE_URL}/family/register-family`
export const FAMILY_SPECIE_COUNT = `${BASE_URL}/family/specie-count`
export const FAMILY_DISABLE = `${BASE_URL}/family/disable`
export const FAMILY_DELETE = `${BASE_URL}/family/delete`
export const FAMILY_REQUEST_DELETE = `${BASE_URL}/family/request-delete`
export const FAMILY_HARD_DELETE = `${BASE_URL}/family/hard-delete`
export const FEATURE_LOCATION = `${BASE_URL}/feature/locations`
export const FEATURE_BY_ID = `${BASE_URL}/feature`
export const FEATURE_POPUP_BY_ID = `${BASE_URL}/feature/popup`
export const FEATURE_UPDATE = `${BASE_URL}/feature/update-feature`
export const FEATURE_CREATE = `${BASE_URL}/feature/create-feature`
export const GEOJSON_FILTERS = `${BASE_URL}/tree/geojson-filters`
export const GEOJSON_FILTERS_ADVANCED = `${BASE_URL}/tree/geojson-filters-advanced`
export const INCONVENIENCE_DISABLE = `${BASE_URL}/inconvenience/disable-inconvenience`
export const INCONVENIENCE_UPDATE = `${BASE_URL}/inconvenience/update-inconvenience`
export const META_FEATURE = `${BASE_URL}/meta-feature`
export const PARISH = `${BASE_URL}/parish`
export const PSEUDONYM = `${BASE_URL}/pseudonym`
export const PSEUDONYM_ACTIVE = `${BASE_URL}/pseudonym/active_pseudonym`
export const PSEUDONYM_BACTH = `${BASE_URL}/pseudonym/register-pseudonym-batch`
export const PSEUDONYM_BY_SPECIE = `${BASE_URL}/pseudonym/for-specie`
export const PSEUDONYM_DELETE = `${BASE_URL}/pseudonym/delete_pseudonym`
export const PSEUDONYM_REQUEST_DELETE = `${BASE_URL}/pseudonym/request-delete`
export const PSEUDONYM_HARD_DELETE = `${BASE_URL}/pseudonym/hard-delete`
export const PSEUDONYM_ADMIN_LIST = `${BASE_URL}/pseudonym/admin-list`
export const PSEUDONYM_UPDATE = `${BASE_URL}/pseudonym/update-pseudonym`
export const PROJECT = `${BASE_URL}/project`
export const PROJECT_UPDATE_DOWNLOAD_COUNTER = `${BASE_URL}/project/update-download`
export const ROLE = `${BASE_URL}/role`
export const SITE = `${BASE_URL}/site`
export const SITE_CREATE = `${BASE_URL}/site/register-site`
export const SITE_BY_NAME = `${BASE_URL}/site/for-name`
export const SITE_BY_PARISH = `${BASE_URL}/site/by-parish`
export const SPECIE = `${BASE_URL}/specie`
export const SPECIE_TOTAL = `${BASE_URL}/specie/count-only`
export const SPECIE_GENDER_TOTAL = `${BASE_URL}/specie/count-gender-only`
export const SPECIE_UPDATE = `${BASE_URL}/specie/update-specie`
export const SPECIE_CREATE = `${BASE_URL}/specie/register-specie`
export const SPECIE_FOR_FAMILY = `${BASE_URL}/specie/filter-family`
export const SPECIE_VERIFIED_WITH_FAMILY = `${BASE_URL}/specie/family-verified`
export const SPECIE_DISABLE = `${BASE_URL}/specie/disable`
export const SPECIE_DELETE = `${BASE_URL}/specie`
export const SPECIE_REQUEST_DELETE = `${BASE_URL}/specie/request-delete`
export const SPECIE_HARD_DELETE = `${BASE_URL}/specie/hard-delete`
export const SPECIE_TREES = `${BASE_URL}/specie`
export const TREE_PHOTOS_UPLOAD = `${BASE_URL}/tree-photos/upload`
export const TREE_REGISTER_COMPLETE = `${BASE_URL}/tree/register-complete`
export const TREE_PREVIEW_GOOGLE_CODE = `${BASE_URL}/tree/preview-google-code`
export const TREE_PREVIEW_PLUS_CODE = `${BASE_URL}/tree/preview-plus-code`
export const TREE_GOOGLE_CODE_PREVIEW = `${BASE_URL}/tree/google-code-preview`
export const TREE_UPDATE = `${BASE_URL}/tree/update-tree`
export const TREE_REASSIGN = `${BASE_URL}/tree/reassign`
export const TREE_UPDATE_STATUS_REGISTER = `${BASE_URL}/tree/update-status-register`
export const TREE_ENABLE_CODES = `${BASE_URL}/tree/all-enabled-tree-codes`
export const TREE_RESOLVE = `${BASE_URL}/tree/resolve`
export const TREE_VALID = `${BASE_URL}/tree/is-valid`
export const TREE_DELETE = `${BASE_URL}/tree/delete`
export const TREE_ADMIN_LIST = `${BASE_URL}/tree/admin-list`
export const TREE_REQUEST_DELETE = `${BASE_URL}/tree/request-delete`
export const TREE_HARD_DELETE = `${BASE_URL}/tree/hard-delete`
export const REPORT_COUNT_TREE = `${BASE_URL}/public-reports/countTree`
export const REPORT_DATA = `${BASE_URL}/report/data`
export const REPORT_HEADERS = `${BASE_URL}/report/headers`
export const REPORT_PUBLIC_HEADERS = `${BASE_URL}/public-reports/headers`
export const REPORT_PUBLIC_DATA = `${BASE_URL}/public-reports/data`
export const TYPE_REQUESTED = `${BASE_URL}/type-requested`
export const ZONE_TYPES = `${BASE_URL}/zone-types`
export const SITE_TYPES = `${BASE_URL}/site-types`
export const NEWS_API = `${BASE_URL}/news`
export const PUBLIC_EVENTS_API = `${BASE_URL}/public-events`
export const CONTACT_FORM = `${BASE_URL}/contact`
export const TREE_PHOTOS = `${BASE_URL}/tree-photos`

// NOMBRES RUTAS DE PAGINAS ARBOLEC//
// Fallback estático - la ciudad real se obtiene del contexto CitiesProvider
export const DEFAULT_CITY = 'loja'
export const ABOUT = 'nosotros'
export const AUTH = 'iniciar-sesion'
export const AUTH_AUTHORIZE_USER = 'auth/authorize-user'
export const AUTH_RESET_PASSWORD = 'auth/reset-password'
export const AUTHENTICATION = 'autenticacion'
export const CONTACT = 'contacto'
export const FORGOT_PASSWORD = 'recuperar-clave'
export const GENERATE_REPORT = 'generar-reporte'
export const MANAGEMENT_TREE = 'editar-arbol'
export const ADMINISTRATION = 'administracion'
export const NOT_FOUND_404 = '*'
export const NEWS = 'noticias'
export const REGISTER_TREE = 'registrar-arbol'
export const REGISTER_USER = 'registrar-usuario'
export const TABLE_RECORDS = 'table-records'
export const TEAM = 'equipo'
export const TREE = 'loja'
export const PROFILE = 'perfil'
export const PUBLICATIONS = 'publicaciones'
export const TERRITORIAL_MANAGEMENT = 'administrar-territorial'

// Tabs de Administración
export const ADMINISTRATION_TAB_FAMILIES = 'familias'
export const ADMINISTRATION_TAB_TREES = 'arboles'
export const ADMINISTRATION_TAB_SPECIES = 'especies'
export const ADMINISTRATION_TAB_USERS = 'usuarios'
export const ADMINISTRATION_TAB_PSEUDONYMS = 'pseudonimos'
export const ADMINISTRATION_TAB_NEWS = 'noticias'
export const ADMINISTRATION_TAB_TESTS = 'pruebas'

// Tabs de Administración Territorial
export const TERRITORIAL_TAB_COUNTRY = 'pais'
export const TERRITORIAL_TAB_PROVINCE = 'provincia'
export const TERRITORIAL_TAB_CANTON = 'canton'
export const TERRITORIAL_TAB_PARISH = 'parroquia'
export const TERRITORIAL_TAB_TENANTS = 'tenants'
export const TERRITORIAL_TAB_ASSOCIATIONS = 'asociaciones'
export const TERRITORIAL_TAB_REASSIGNMENT = 'reasignacion'
